// extracted by mini-css-extract-plugin
module.exports = {"illustrations":"DamageIllustrations_illustrations__2sgzS"};